export enum BuildCacheMode {
    Disabled,
    ReadOnly,
    UpdateIfNeed,
    ForceUpdate,
}

export function parseBuildCacheMode(input: string): BuildCacheMode {
    const normalizedInput = input.toLowerCase();
    if (normalizedInput === "disabled") {
        return BuildCacheMode.Disabled;
    } else if (normalizedInput === "readonly") {
        return BuildCacheMode.ReadOnly;
    } else if (normalizedInput === "update") {
        return BuildCacheMode.UpdateIfNeed;
    } else if (normalizedInput === "force-update") {
        return BuildCacheMode.ForceUpdate;
    }
    throw new Error(`Invalid build cache mode value. Available values: . Got: ${input}`);
}
